<template>
  <div>
    <div v-if="showFreeTrial" class="mask" />
    <div v-if="showFreeTrial" class="free-trial-form">
      <div class="form-body">
        <img :src="trialTop" alt="免费体验">
        <div class="custom-title">定制专属解决方案</div>
        <Form ref="form" :rules="rules" :model="form">
          <FormItem prop="phone">
            <Input v-model="form.phone" placeholder="请输入手机号（必填）" prefix-icon="el-icon-cellphone" class="custom-phone" />
          </FormItem>
          <FormItem prop="name">
            <Input v-model="form.name" placeholder="请输入姓名" prefix-icon="el-icon-name" class="custom-name" />
          </FormItem>
          <FormItem prop="company">
            <Input v-model="form.company" placeholder="请输入企业名称" prefix-icon="el-icon-enterprise" class="custom-enterprise" />
          </FormItem>
          <FormItem prop="position">
            <Input v-model="form.position" placeholder="请输入职位" prefix-icon="el-icon-duty" class="custom-duty" />
          </FormItem>
          <FormItem prop="industry">
            <Input v-model="form.industry" placeholder="请输入所在行业" prefix-icon="el-icon-industry" class="custom-industry" />
          </FormItem>
          <Button type="primary" style="width: 440px;height: 48px;" @click="handleSubmit">提交</Button>
        </Form>
      </div>
      <div class="close-btn" @click="handleShowFormModal(false)" />
    </div>
  </div>
</template>
<script>
import { saveFreeExperience } from '../api'
import { Form, FormItem, Input, Button, Message } from 'element-ui'
import trialTop from '@/assets/freeTrial/free-trial-top.png'
export default {
  name: 'TrialForm',
  components: {
    Form,
    FormItem,
    Input,
    Button
  },
  props: {
    showFreeTrial: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      trialTop,
      form: {},
      rules: {
        name: [
          { pattern: /^[\u4e00-\u9fa5]{0,}$/, message: '请输入正确的姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          { pattern: /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/, message: '请输入正确的电话', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleShowFormModal(val) {
      this.$emit('handleShowFormModal', val)
      // this.showFreeTrial = val
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          saveFreeExperience({ ...this.form }).then(_ => {
            Message({
              showClose: true,
              message: '反馈成功',
              type: 'success'
            })
            this.handleShowFormModal(false)
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background-color: #333;
  opacity: 0.4;
  z-index: 99;
}
.free-trial-form {
  position: fixed;
  display: flex;
  top: 50%;
  left: 50%;
  transform: translate(calc(-50%), calc(-50%));
  z-index: 999;
  width: 541px;
	height: 610px;
  z-index: 999;
  .form-body {
    background-color: #fff;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .custom-title {
      width: 100%;
      position: absolute;
      top: 50px;
      left: 50%;
      transform: translate(-50%, 0);
      // font-family: PangMenZhengDao-XiXian;
      font-size: 36px;
      line-height: 64px;
      color: #fff;
      text-align: center;
    }
    /deep/ .el-form {
      margin-top: 49px;
      width: 440px;
      .el-form-item {
        margin-bottom: 17px;
      }
      .el-form-item__content {
        line-height: 48px;
      }
      .el-input {
        font-size: 18px;
      }
      .el-input__inner {
        height: 48px;
        line-height: 48px;
      }
    }
    .custom-input {
      width: 100%;
      margin-bottom: 20px;
    }
    /deep/ .el-input--prefix .el-input__inner {
      padding-left: 75px;
    }
    .custom-phone {
      /deep/ .el-input__prefix {
        margin-left: 20px;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url('../assets/freeTrial/smartphone.png');
      }
    }
    .custom-name {
      /deep/ .el-input__prefix {
        margin-left: 20px;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url('../assets/freeTrial/name.png');
      }
    }
    .custom-enterprise {
      /deep/ .el-input__prefix {
        margin-left: 20px;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url('../assets/freeTrial/enterprise.png');
      }
    }
    .custom-duty {
      /deep/ .el-input__prefix {
        margin-left: 20px;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url('../assets/freeTrial/duty.png');
      }
    }
    .custom-industry {
      /deep/ .el-input__prefix {
        margin-left: 20px;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url('../assets/freeTrial/industry.png');
      }
    }
  }
  .close-btn {
    position: absolute;
    right: -41px;
    top: 13px;
    width: 33px;
    height: 33px;
    background-repeat: no-repeat;
    background-image: url('../assets/freeTrial/dialog-close.png');
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
